/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Numbersmoretitle2Inputs */

const en_numbersmoretitle2 = /** @type {(inputs: Numbersmoretitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

const de_numbersmoretitle2 = /** @type {(inputs: Numbersmoretitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiteres`)
};

/**
* | output |
* | --- |
* | "More" |
*
* @param {Numbersmoretitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const numbersmoretitle2 = /** @type {((inputs?: Numbersmoretitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Numbersmoretitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_numbersmoretitle2(inputs)
	return de_numbersmoretitle2(inputs)
});
export { numbersmoretitle2 as "numbersMoreTitle" }